import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';

const initialState = {
	loading: false,
	error: null,
	list: [],
	zonesList: [],
};

export default function sites(state = initialState, action) {
	switch (action.type) {
		// after START action set LOADING clear ERR
		case actionTypes.SITES_START:
			return {
				...state,
				loading: true,
				errors: null,
			};
		// if response FAILED set ERR and clear LOADING
		case actionTypes.SITES_FAILED:
			return {
				...state,
				loading: false,
				errors: action.payload.errors,
			};
		// 	SUCCEED response below:
		// 	on SUCCEED clear ERR and LOADING, set RESPONSE:
		case actionTypes.SITES_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				list: action.payload,
			};
		case actionTypes.SITES_ZONES_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				zonesList: action.payload,
			};
		case actionTypes.SITES_ZONES_LIST_CLEAR:
			return {
				...state,
				loading: false,
				error: null,
				zonesList: [],
			};
		case actionTypes.AUTH_LOGOUT:
			return initialState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/reducers/sites.js